<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/additional.svg" />
          </div>
          <div>
            <div class="card_title_1">
              ADDITIONAL GENERATION CAPACITY - PROJECT MANAGEMENT
            </div>
            <!-- <div class="card_title_2">Last Updated {{ last_update }}</div> -->
          </div>
        </div>
        <div></div>
      </div>
    </div>

    <div class="card-body" style="padding: 20px">
      <div class="row">
        <div class="col-md-5">
          <div
            class="card"
            style="
              box-shadow: none;
              border-radius: 8px;
              background-color: #efefef;
            "
          >
            <div class="card-body">
              <div
                class="text mb-4 d-flex"
                style="justify-content: space-between; align-items: center"
              >
                <h5 class="title">THERMAL GENERATION CAPACITY</h5>
                <div>
                  <span
                    class="tab-link"
                    :class="{
                      'tab-selected': selectedTabThermal === 'consolidated',
                    }"
                    @click="selectTabThermal('consolidated')"
                    >All</span
                  >
                  |
                  <span
                    class="tab-link"
                    :class="{ 'tab-selected': selectedTabThermal === 'ipp' }"
                    @click="selectTabThermal('ipp')"
                    >IPP</span
                  >
                  |
                  <span
                    class="tab-link"
                    :class="{ 'tab-selected': selectedTabThermal === 'pln' }"
                    @click="selectTabThermal('pln')"
                    >PLN</span
                  >
                </div>
              </div>
              <div class="row thermal-mobile mbl-gen" style="height: 250px">
                <div class="col-md-6" style="padding: 0 4px; height: 100%">
                  <CardAdditionalGenerationCapacity
                    v-if="thermal.length > 0"
                    :param="thermal[0]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        'THERMAL',
                        selectedTabThermal,
                        'ALL',
                        thermal[0]
                      )
                    "
                    style="margin-bottom: 20px; height: 100%"
                  ></CardAdditionalGenerationCapacity>
                </div>
                <div class="col-md-6" style="padding: 0 4px; height: 100%">
                  <CardAdditionalGenerationCapacity
                    v-if="thermal.length > 0"
                    :param="thermal[1]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        'THERMAL',
                        selectedTabThermal,
                        'ALL',
                        thermal[1]
                      )
                    "
                    style="margin-bottom: 8px; height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>
                  <CardAdditionalGenerationCapacity
                    v-if="thermal.length > 0"
                    :param="thermal[2]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        'THERMAL',
                        selectedTabThermal,
                        'ALL',
                        thermal[2]
                      )
                    "
                    style="height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <div
            class="card"
            style="
              box-shadow: none;
              border-radius: 8px;
              background-color: #efefef;
            "
          >
            <div class="card-body">
              <div
                class="text mb-4 d-flex"
                style="justify-content: space-between; align-items: center"
              >
                <h5 class="title">EBT GENERATION CAPACITY</h5>
                <div>
                  <span
                    class="tab-link"
                    :class="{
                      'tab-selected': selectedTabEbt === 'consolidated',
                    }"
                    @click="selectTabEbt('consolidated')"
                    >All</span
                  >
                  |
                  <span
                    class="tab-link"
                    :class="{ 'tab-selected': selectedTabEbt === 'ipp' }"
                    @click="selectTabEbt('ipp')"
                    >IPP</span
                  >
                  |
                  <span
                    class="tab-link"
                    :class="{ 'tab-selected': selectedTabEbt === 'pln' }"
                    @click="selectTabEbt('pln')"
                    >PLN</span
                  >
                </div>
              </div>
              <div class="row thermal-mobile mbl-gen" style="height: 250px">
                <div class="col-md-4" style="padding: 0 4px; height: 100%">
                  <CardAdditionalGenerationCapacity
                    v-if="ebt.length > 0"
                    :param="ebt[0]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        'EBT',
                        selectedTabEbt,
                        'ALL',
                        ebt[0]
                      )
                    "
                    style="margin-bottom: 20px; height: 100%"
                  ></CardAdditionalGenerationCapacity>
                </div>
                <div class="col-md-4" style="padding: 0 4px; height: 100%">
                  <CardAdditionalGenerationCapacity
                    v-if="ebt.length > 0"
                    :param="ebt[1]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        'EBT',
                        selectedTabEbt,
                        'ALL',
                        ebt[1]
                      )
                    "
                    style="margin-bottom: 8px; height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>

                  <CardAdditionalGenerationCapacity
                    v-if="ebt.length > 0"
                    :param="ebt[2]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        'EBT',
                        selectedTabEbt,
                        'ALL',
                        ebt[2]
                      )
                    "
                    style="height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>
                </div>
                <div class="col-md-4" style="padding: 0 4px; height: 100%">
                  <CardAdditionalGenerationCapacity
                    v-if="ebt.length > 0"
                    :param="ebt[3]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        'EBT',
                        selectedTabEbt,
                        'ALL',
                        ebt[3]
                      )
                    "
                    style="margin-bottom: 8px; height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>

                  <CardAdditionalGenerationCapacity
                    v-if="ebt.length > 0"
                    :param="ebt[4]"
                    @showGraph="
                      onShowModalGenerationCapacity(
                        'EBT',
                        selectedTabEbt,
                        'ALL',
                        ebt[4]
                      )
                    "
                    style="height: calc(50% - 4px)"
                  ></CardAdditionalGenerationCapacity>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalGenerationCapacity
      :showModal="modalGenerationCapacity.show"
      :projects="projects"
      :filter="filter"
      :title="titleDetail"
      :lastUpdate="lastUpdate"
      @closeModal="onCloseModalGenerationCapacity"
    />
  </div>
</template>
<script>
import ModalGenerationCapacity from "../modals/ModalGenerationCapacity.vue";
import CardAdditionalGenerationCapacity from "./CardAdditionalGenerationCapacity.vue";
import GenerationService from "@/services/generation/generation";
const apiGeneration = GenerationService.build();

export default {
  props: ["data"],
  components: {
    CardAdditionalGenerationCapacity,
    ModalGenerationCapacity,
  },
  data() {
    return {
      last_update: "",
      lastUpdate: "",
      modalGenerationCapacity: {
        show: false,
        load: false,
      },
      thermal: [],
      ebt: [],

      selectedTabThermal: "consolidated",
      selectedTabEbt: "consolidated",

      filter: {
        owner: "",
        type: "",
        category: "",
      },
      titleDetail: "",
      projects: [],
    };
  },
  mounted() {
    this.getDataThermal("consolidated");
    this.getDataEbt("consolidated");
  },
  methods: {
    async getDataGenerationAdditional(typeAdditional, typeGeneration) {
      let param = Object.assign({
        typeAdditional: typeAdditional,
        typeGeneration: typeGeneration,
      });
      const res = await apiGeneration.getDataGenerationAdditional(param);
      if (res && res.status == 200) {
        this.last_update = res.data.lastUpdate;
        return res.data.data.data;
      }

      return [];
    },

    async getDataThermal(typeGeneration) {
      this.thermal = await this.getDataGenerationAdditional(
        "thermal",
        typeGeneration
      );
    },

    async getDataEbt(typeGeneration) {
      this.ebt = await this.getDataGenerationAdditional("ebt", typeGeneration);
    },

    selectTabThermal(tab) {
      this.selectedTabThermal = tab;
      this.getDataThermal(tab);
    },

    selectTabEbt(tab) {
      this.selectedTabEbt = tab;
      this.getDataEbt(tab);
    },

    onShowModalGenerationCapacity(owner, category, type, data) {
      this.filter = {
        owner: owner,
        type: type,
        category: category,
      };
      this.getDataGenerationAdditionalDetail(owner, category, type, data);
    },
    async getDataGenerationAdditionalDetail(
      typeAdditional,
      typeGeneration,
      instanceId,
      data
    ) {
      let param = Object.assign({
        parentId: typeAdditional,
        metricId:
          data.metricId === "THERMAL" || data.metricId === "EBT"
            ? "ALL"
            : data.metricId,
        instanceId: typeGeneration === "consolidated" ? "ALL" : typeGeneration,
      });
      const res = await apiGeneration.getDataGenerationAdditionalDetail(param);
      this.projects = res.data.data;
      this.titleDetail = data.metricName;
      this.lastUpdate = res.data.lastUpdate;
      this.modalGenerationCapacity.show = true;
    },
    onCloseModalGenerationCapacity(value) {
      this.modalGenerationCapacity.show = value;
    },
  },
};
</script>

<style>
.tab-link {
  cursor: pointer;
}

.tab-selected {
  color: #00a3e9;
  text-decoration: underline;
}
</style>
